/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

const ACTIVE_MENU_CLASS_PREFIX = "tri-proj-menu-";
const ACTIVE_TOP_PARENT_MENU_CLASS_SUFFIX = "-top-parent";
const ACTIVE_MENU_ITEM_CLASS = "triProjectSubMenuItemActive"
const ACTIVE_TOP_PARENT_MENU_ITEM_CLASS = "triProjectSubMenuItemTopParentActive";
const ACTIVE_MENU_ITEM_BACKGROUND_CLASS = "triProjectSubMenuItemActiveBackground";
const ACTIVE_TOP_PARENT_MENU_ITEM_BACKGROUND_CLASS = "triProjectSubMenuItemTopParentActiveBackground"
const ACTIVE_CLOSEST_PARENT_MENU_ITEM_BACKGROUND_CLASS = "triProjectSubMenuItemClosestParentActiveBackground"

export class ActiveProjectSubMenuItemHandler {

    constructor(hierarchyListItemHandler) {
        this.hierarchyListItemHandler = hierarchyListItemHandler;
        this.currentActiveProjectSubMenuId = null;
        this.currentActiveTopParentProjectSubMenuId = null;
    }

    handle(menuId) {

        if (menuId) {
          let selectedMenuItem = this.hierarchyListItemHandler.handleValidMenuItem(menuId);
            //If menu item is opening in new window, active menu should stay the same for current page.
          if (selectedMenuItem.isOpenInNewWindow) {
            return;
          }
        }
        //First remove menu active classes
        this._removeActiveMenuItemClasses();

        //If menu id is not defined, stick with previous values. This means we are coming from a toggle.
        if (menuId) {
            this.currentActiveProjectSubMenuId = this.generateMenuItemId(menuId);
            let topParentMenuIdNoPrefix = this.hierarchyListItemHandler.getListItemById(menuId).topParentMenuId;
            if (topParentMenuIdNoPrefix != null) {
                this.currentActiveTopParentProjectSubMenuId = this.generateMenuItemId(topParentMenuIdNoPrefix);
            } else {
                this.currentActiveTopParentProjectSubMenuId = null;
            }
        }

        var triProjectSubMenuItemElement;
        var triProjectSubMenuItemTopParentElement;
        //Add active to selected menu and top parent
        triProjectSubMenuItemElement = document.getElementById(this.currentActiveProjectSubMenuId);
        if (triProjectSubMenuItemElement != null) {
           triProjectSubMenuItemElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_MENU_ITEM_BACKGROUND_CLASS);
           triProjectSubMenuItemElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_MENU_ITEM_CLASS);
        }

        if (this.currentActiveTopParentProjectSubMenuId != null) {
            triProjectSubMenuItemTopParentElement = document.getElementById(this.currentActiveTopParentProjectSubMenuId);
            triProjectSubMenuItemTopParentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_TOP_PARENT_MENU_ITEM_BACKGROUND_CLASS);
            triProjectSubMenuItemTopParentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_TOP_PARENT_MENU_ITEM_CLASS);
        }
        
        //Setting the closest parent active class is only necessary if the actual selected menu is not found.
        //This indicates the top parent is collapsed.
        if (triProjectSubMenuItemElement == null && this.currentActiveProjectSubMenuId != null) {
            let currentActiveMenuItem = this.hierarchyListItemHandler.getListItemById(this.currentActiveProjectSubMenuId.replace(ACTIVE_MENU_CLASS_PREFIX,""));
            let ascendingParentIds = currentActiveMenuItem.ascendingParentIds;
            for (var i = 0; i < ascendingParentIds.length; i++) {
                let closestParentElementId = this.generateMenuItemId(ascendingParentIds[i]);
                let closestParentElement = document.getElementById(closestParentElementId);
                if (closestParentElement != null) {
                    closestParentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add(ACTIVE_CLOSEST_PARENT_MENU_ITEM_BACKGROUND_CLASS);
                    break;
                }
            }
        }   
    } 

    _removeActiveMenuItemClasses() {
        var triProjectSubMenuItemElement;
        var triProjectSubMenuItemTopParentElement;
       
        if (this.currentActiveProjectSubMenuId != null) {
            triProjectSubMenuItemElement = document.getElementById(this.currentActiveProjectSubMenuId);
            if (triProjectSubMenuItemElement != null) {
                triProjectSubMenuItemElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_MENU_ITEM_BACKGROUND_CLASS);
                triProjectSubMenuItemElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_MENU_ITEM_CLASS);    
            }
        }

        if (this.currentActiveTopParentProjectSubMenuId != null) {
            triProjectSubMenuItemTopParentElement = document.getElementById(this.currentActiveTopParentProjectSubMenuId);
            triProjectSubMenuItemTopParentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_CLOSEST_PARENT_MENU_ITEM_BACKGROUND_CLASS);
            triProjectSubMenuItemTopParentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_TOP_PARENT_MENU_ITEM_BACKGROUND_CLASS);
            triProjectSubMenuItemTopParentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_TOP_PARENT_MENU_ITEM_CLASS);
        }

        //remove all decesendant active background classes
        let currentTopMenuItemId = this.currentActiveTopParentProjectSubMenuId != null ? 
                                this.currentActiveTopParentProjectSubMenuId: this.currentActiveProjectSubMenuId;
        let topParentMenuItemTagName = this.generateTopParentMenuItemName(currentTopMenuItemId);
        let elementsWithParentTagNames = document.getElementsByName(topParentMenuItemTagName);
        for (var i = 0; i < elementsWithParentTagNames.length; i++) {
            elementsWithParentTagNames[i].parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove(ACTIVE_CLOSEST_PARENT_MENU_ITEM_BACKGROUND_CLASS);
        }
    }

    generateMenuItemId(menuId) {
        return ACTIVE_MENU_CLASS_PREFIX + menuId;
    }

    generateTopParentMenuItemName(topParentMenuId) {
       return topParentMenuId+ACTIVE_TOP_PARENT_MENU_CLASS_SUFFIX;
    }

    resetCurrentActiveIds() {
        this._removeActiveMenuItemClasses();
        this.currentActiveProjectSubMenuId = null;
        this.currentActiveTopParentProjectSubMenuId = null;
    }
}